import { useEffect, useMemo, useState } from "react";
import useLenis from "../hooks/useLenis";
import { fetchProducts, fetchSettings } from "../lib/api";
import { DEFAULT_SETTINGS } from "../lib/site";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import { Grain, Marquee } from "../components/Decor";
import { About, ParallaxStory, Philosophy } from "../components/Story";
import { CategoryCards, ComingSoonBand, Shop } from "../components/Catalog";
import { Gallery, Journey, WhyChoose } from "../components/Journey";
import { ContactSection, Footer } from "../components/Contact";
import ProductModal from "../components/ProductModal";
import EnquiryModal from "../components/EnquiryModal";
import ChatWidget from "../components/ChatWidget";

export default function Home() {
  useLenis();
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [viewProduct, setViewProduct] = useState(null);
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [enquiryProduct, setEnquiryProduct] = useState(null);

  useEffect(() => {
    fetchProducts().then(setProducts).catch(() => {});
    fetchSettings()
      .then((s) => setSettings({ ...DEFAULT_SETTINGS, ...s }))
      .catch(() => {});
  }, []);

  const openEnquire = (product) => {
    setViewProduct(null);
    setEnquiryProduct(product || null);
    setEnquiryOpen(true);
  };

  const comingSoon = useMemo(
    () => products.filter((p) => p.availability === "coming_soon"),
    [products]
  );

  return (
    <div className="bg-cream text-ink antialiased">
      <Grain />
      <Navbar onEnquire={() => openEnquire(null)} />
      <main>
        <Hero />
        <Marquee />
        <ParallaxStory />
        <About />
        <Philosophy />
        <CategoryCards />
        <Shop products={products} onView={setViewProduct} onEnquire={openEnquire} />
        <Journey />
        <ComingSoonBand products={comingSoon} onNotify={openEnquire} />
        <Gallery />
        <WhyChoose />
        <Marquee dark={false} />
        <ContactSection settings={settings} />
      </main>
      <Footer settings={settings} />
      <ProductModal product={viewProduct} onClose={() => setViewProduct(null)} onEnquire={openEnquire} />
      <EnquiryModal
        open={enquiryOpen}
        product={enquiryProduct}
        settings={settings}
        onClose={() => setEnquiryOpen(false)}
      />
      <ChatWidget />
    </div>
  );
}
